import { CmsMedia, TButtonData } from '@renderer-ui-library/molecules';
import { BlockType } from 'blocks/BlockType';
import { IBaseBlockData } from 'blocks/IBaseBlockData';

export enum ServiceTypes {
    Inspection = 'Inspection',
    Warranty = 'Warranty',
    Transport = 'Transport',
    Payment = 'Payment',
    Financing = 'Financing',
    Customers = 'Customers',
    PartnerDealers = 'Partner Dealers',
    Homologation = 'Homologation',
}

export interface Service {
    serviceType: ServiceTypes;
    headline: string | null;
    description: string;
    media: CmsMedia | null;
    button: TButtonData | null;
}

export interface IMachineOverviewBlockData extends IBaseBlockData {
    type: BlockType.MachineOverview;
    services: Service[];
}
